// Bootstrap is now loaded separately via bootstrap-bundle.min.js
// Access Bootstrap components via window.bootstrap
import { CookieBanner } from "./components/cookieBanner";
import { AnnouncementBanner } from "./components/announcementBanner";

// Custom HTML sanitizer to prevent XSS
function sanitizeHTML(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  
  // Remove dangerous tags
  const dangerousTags = [
    'script', 'iframe', 'object', 'embed', 'link', 'style', 'form',
    'input', 'textarea', 'button', 'select', 'option', 'base', 
    'meta', 'applet', 'svg', 'math', 'template', 'audio', 'video'
  ];
  dangerousTags.forEach(tag => {
    const elements = doc.querySelectorAll(tag);
    elements.forEach(el => el.remove());
  });
  
  // Remove dangerous attributes from all elements
  const allElements = doc.querySelectorAll('*');
  const dangerousProtocols = /^[\s\0]*(?:javascript|data|vbscript|file|about):/i;
  
  allElements.forEach(el => {
    Array.from(el.attributes).forEach(attr => {
      const attrName = attr.name.toLowerCase();
      const attrValue = attr.value.toLowerCase().trim();
      
      // Remove event handlers (onclick, onload, onerror, etc.)
      if (attrName.startsWith('on')) {
        el.removeAttribute(attr.name);
        return;
      }
      
      // Remove dangerous attributes
      if (['formaction', 'form', 'action', 'srcdoc', 'sandbox'].includes(attrName)) {
        el.removeAttribute(attr.name);
        return;
      }
      
      // Remove dangerous protocols in href, src, data, etc. (check decoded value)
      if (attr.value) {
        const decodedValue = decodeURIComponent(attr.value).replace(/[\s\0]/g, '');
        if (dangerousProtocols.test(decodedValue)) {
          el.removeAttribute(attr.name);
        }
      }
    });
  });
  
  // Return sanitized HTML using a safer approach
  const sanitized = doc.body.innerHTML;
  
  // Additional check: ensure no script tags slipped through
  if (/<script/i.test(sanitized)) {
    console.warn('Potential XSS attempt blocked');
    return '';
  }
  
  return sanitized;
}

document.addEventListener("DOMContentLoaded", function () {
  const banner = document.querySelector("section.banner");
  const announcementBanner = document.querySelector("section.announcement");

  if (banner) {
    const bannerEl = new CookieBanner(banner);
  }

  if (announcementBanner) {
    const bannerEl = new AnnouncementBanner(announcementBanner);
  }


  const childLinks = document.querySelectorAll(".sub-menu");
 
  childLinks.forEach((link) => {
    link.addEventListener("mouseover", (event) => {
      const parentElement = event.target.closest(".menu-item-has-children");
      if (parentElement) {
        parentElement.classList.add("hover");
      }
    });
 
    link.addEventListener("mouseout", (event) => {
      const parentElement = event.target.closest(".menu-item-has-children");
      if (parentElement) {
        parentElement.classList.remove("hover");
      }
    });
  });

});

window.addEventListener("scroll", () => {
  const header = document.querySelector(".navbar.fixed-top");
  if (window.scrollY > 10) {
    header.classList.add("navbar__shadow");
  } else {
    header.classList.remove("navbar__shadow");
  }
});


document.addEventListener('DOMContentLoaded', () => {
        const filterButtons = document.querySelectorAll('#learn__filter button');
        const sortDropdown = document.getElementById('learn__filter__date');
        const tagDropdown = document.getElementById('learn__tag');
        const cardsContainer = document.getElementById('cards-container');
 
        const fetchArticles = () => {

            const selectedCategory = document.querySelector('#learn__filter button.active')?.dataset.category || '';
            const selectedSortOrder = sortDropdown ? sortDropdown.value : '';
            const selctedTagDropdown = tagDropdown ? tagDropdown.value : '';

            if (!cardsContainer) return;
 
            const formData = new FormData();
            formData.append('action', 'filter_articles');
            formData.append('category', selectedCategory);
            formData.append('sort_order', selectedSortOrder);
            formData.append('tag', selctedTagDropdown);
 
            fetch(myAjax.ajaxurl, {
                method: 'POST',
                body: formData
            })
            .then(response => response.text())
            .then(data => {
              cardsContainer.innerHTML = sanitizeHTML(data);
              lazyLoad();

            })
            .catch(error => console.error('Error:', error));
        };
 
        filterButtons.forEach(button => {
            button.addEventListener('click', () => {
                filterButtons.forEach(btn => btn.classList.remove('active'));
                button.classList.add('active');
                fetchArticles();
            });
        });
 
        if (sortDropdown) {
          sortDropdown.addEventListener('change', fetchArticles);
          tagDropdown.addEventListener('change', fetchArticles);
        }
 
        fetchArticles();


        //UU-18493
        const accordionItems = document.querySelectorAll('.accordion-item');
    
        if (accordionItems.length > 0) {
            accordionItems.forEach(item => {
            const collapseDiv = item.querySelector('.accordion-collapse');
            
            if (collapseDiv) {
                function updateOpenClass() {
                    if (collapseDiv.classList.contains('show')) {
                        item.classList.add('open');
                    } else {
                        item.classList.remove('open');
                    }
                }

                updateOpenClass();
                
                collapseDiv.addEventListener('shown.bs.collapse', function() {
                    item.classList.add('open');
                });
                
                collapseDiv.addEventListener('hidden.bs.collapse', function() {
                    item.classList.remove('open');
                });
            }
            });
        }

    });

      const lazyLoad = () => {
        const cards = document.querySelectorAll(".card");

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("visible");
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.5 }
        );

        cards.forEach((card) => {
          observer.observe(card);
        });
      };

         
function revealModalFromHash() {
  if (location.hash && location.hash.replace('#', '') === 'salesModal') {
    const modalElem = document.getElementById('salesModal');
    if (modalElem && typeof window.bootstrap !== 'undefined') {
      new window.bootstrap.Modal(modalElem).show();
    }
  }
}

window.addEventListener('load', revealModalFromHash);
window.addEventListener('hashchange', revealModalFromHash);


